export default __webpack_public_path__ + "static/media/admin.49a15ebc.svg";